import clsx from 'clsx'
import React from 'react'
import { makeStyles } from '@mui/styles'
import { useDispatch, useSelector } from 'react-redux'

import lang from '@/lang'
import ThemeInterface from '@/theme-interface'
import { ROLES } from '@/modules/base/util/constants'
import ArrowUp from '@assets/images/icons/arr_up.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import RichTooltip from '@/modules/base/components/rich-tooltip/rich-tooltip'
import { openTenantSelection } from '@/redux/ducks/tenant/selection'
import ProfileDetailsTooltip from '@/modules/layout/components/submenu/profie-section/profile-details-tooltip'
import TenantSelectionDrawer from '@/modules/base/components/tenant-selection/tenant-selection-drawer'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    color: theme.white,
  },
  tenantWrapper: {
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      color: theme.primaryBright,
      '& $arrow path': {
        fill: theme.primaryBright,
      },
    },
  },
  label: {
    fontSize: theme.fontSizes.smaller,
    color: theme.mode.color.medium,
    textAlign: 'right',
  },
  tenant: {
    fontSize: theme.fontSizes.smaller,
  },
  arrow: {
    marginLeft: 6,
    transform: 'rotate(180deg)',
    '& path': {
      fill: theme.white,
    },
  },
  open: {
    color: theme.primaryBright,
    '& $arrow': {
      transform: 'rotate(0deg)',
    },
    '& $arrow path': {
      fill: theme.primaryBright,
    },
  },
  tooltip: {
    backgroundColor: theme.mode.backgroundColor.default,
    color: theme.mode.color.default,
  },
  tooltipArrow: {
    color: theme.mode.backgroundColor.default,
  },
  tooltipContent: {
    backgroundColor: theme.mode.backgroundColor.default,
    color: theme.mode.color.default,
  },
}), { name: 'TenantSelectionDisplay' })

const TenantSelectionDisplay = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const {
    activeTenant,
    tenantId,
    roles,
  } = useSelector(state => state.user.info)
  const { open: tenantSelectionOpen } = useSelector(state => state.tenant.selection)
  const isUserTaxConsultant = roles?.includes(ROLES.TAX_CONSULTANT_ROLE) && activeTenant?.tenantCollaborationId

  const shortCompanyName = (name): string => {
    const MAX_LENGTH = 22
    if (name.length <= MAX_LENGTH) return name
    return `${name.slice(0, MAX_LENGTH)}...`
  }

  const onTenantClick = (): void => {
    dispatch(openTenantSelection())
  }

  const rootClassName = clsx(classes.root, tenantSelectionOpen && classes.open)
  return (
    <>
      <RichTooltip
        content={
          <ProfileDetailsTooltip user={activeTenant} tenantCollaborationId={activeTenant?.tenantCollaborationId} styles={{ root: classes.tooltipContent }} />
        }
        placement='bottom'
        offsetX={50}
        offsetY={-10}
        padding={0}
        width='fit-content'
        disabled={!isUserTaxConsultant}
        styles={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}>
        <div className={rootClassName}>
          {isUserTaxConsultant ? <span className={classes.label}>{lang.menu.profileSection.heading}</span> : null}
          <div className={classes.tenantWrapper} onClick={onTenantClick}>
            <div className={classes.tenant}>
              {activeTenant?.companyName ? shortCompanyName(activeTenant?.companyName) : lang.menu.profileSection.noCompanyName}
              {isUserTaxConsultant && <span> - {tenantId}</span>}
            </div>
            <SVGIcon height='10px' width='10px' svg={ArrowUp} className={classes.arrow} />
          </div>
        </div>
      </RichTooltip>
      <TenantSelectionDrawer />
    </>
  )
}

export default TenantSelectionDisplay
